import type { ComponentProps } from "react";

const GRIP_CLS = "flex h-6 w-6 items-center justify-center text-fg-subtle";

/** Drag-handle grip: two columns of three dots, drawn (not a glyph). */
function GripIcon() {
  return (
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="currentColor"
      aria-hidden="true"
    >
      <circle cx="2.5" cy="3" r="1.4" />
      <circle cx="7.5" cy="3" r="1.4" />
      <circle cx="2.5" cy="8" r="1.4" />
      <circle cx="7.5" cy="8" r="1.4" />
      <circle cx="2.5" cy="13" r="1.4" />
      <circle cx="7.5" cy="13" r="1.4" />
    </svg>
  );
}

/**
 * The grip a sortable row is picked up by. Spread the sortable's
 * `attributes` and `listeners` onto it and hand it the activator ref; the
 * `title` states the action ("Drag to reorder this line"). `ghost` is the
 * inert copy for a DragOverlay — no button, the cursor already grabbing.
 */
export function DragHandle({
  ghost = false,
  className = "",
  ...props
}: ComponentProps<"button"> & { ghost?: boolean }) {
  if (ghost) {
    return (
      <span className={`${GRIP_CLS} cursor-grabbing ${className}`}>
        <GripIcon />
      </span>
    );
  }
  return (
    <button
      type="button"
      className={`${GRIP_CLS} cursor-grab touch-none transition-colors hover:text-fg active:cursor-grabbing disabled:cursor-default disabled:hover:text-fg-subtle ${className}`}
      {...props}
    >
      <GripIcon />
    </button>
  );
}
